<template>
  <div
    id="preset-button"
    class="choice-button uppercase cursor-pointer w-full shadow-md hover:shadow-sm select-none"
    :class="[this.chosen ? 'filled' : '', this.isMultipleSelect ? 'multi-selection' : 'mono-selection']"
    @click="this.buttonClicked"
  >
    <div class="flex flex-col items-center p-2 md:p-4 h-full">
      <AdjustmentsHorizontalIcon class="h-6 w-6" v-if="this.icon == 'closestWidth'" />
      <MinusCircleIcon class="h-6 w-6" v-else-if="this.icon == 'smallestNumberOfElements'" />
      <PlusCircleIcon class="h-6 w-6" v-else-if="this.icon == 'largestNumberOfElements'" />
      <CurrencyEuroIcon class="h-6 w-6" v-else-if="this.icon == 'lowestCost'" />
      <div>{{ this.description }}</div>
      <template v-for="preset in this.presets" :key="preset.id">
        <div id="configuration" class="p-2" :class="preset.id == this.currentlySelectedConfiguration.id ? 'selected' : 'not-selected'">
          <div>Config. n°{{ preset.id }}</div>
          <div class="lowercase">{{ preset.totalPrice() }}€ - {{ preset.totalWidth() }} cm</div>
          <template v-for="obj in this.computeSizesArray(preset.currentConfiguration)" :key="obj">
            <div class="lowercase">{{ obj.count }} &times; {{ obj.width }}cm ({{ obj.price }}€/unité)</div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { AdjustmentsHorizontalIcon, MinusCircleIcon, PlusCircleIcon, CurrencyEuroIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'PresetButton',
  components: {
    AdjustmentsHorizontalIcon,
    MinusCircleIcon,
    PlusCircleIcon,
    CurrencyEuroIcon,
  },
  props: {
    buttonId: {
      type: Number,
      required: true,
    },
    chosen: {
      type: Boolean,
      default: false,
    },
    presets: {
      type: Array,
    },
    icon: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    isMultipleSelect() {
      return this.presets.length > 1;
    },
    currentlySelectedConfiguration() {
      if (this.selectedConfigurationIndex == -1 || this.selectedConfigurationIndex >= this.presets.length) {
        return {};
      }

      return this.presets[this.selectedConfigurationIndex];
    },
  },
  data() {
    return {
      selectedConfigurationIndex: -1,
    };
  },
  methods: {
    computeSizesArray(preset) {
      function widthAlreadyInArray(list, width) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].width == width) {
            return true;
          }
        }

        return false;
      }

      let arr = [];

      for (let i = 0; i < preset.length; i++) {
        if (!widthAlreadyInArray(arr, preset[i].width)) {
          arr.push({
            width: preset[i].width,
            count: preset.filter((obj) => obj.width == preset[i].width).length,
            price: preset[i].price,
          });
        }
      }

      return arr;
    },
    buttonClicked() {
      // Security in case the button has no preset
      if (this.presets.length == 0) {
        return;
      }

      // If the button was already the chosen one
      if (this.chosen) {
        if (this.isMultipleSelect && this.selectedConfigurationIndex + 1 < this.presets.length) {
          // Go to the next configuration
          this.selectedConfigurationIndex++;
        } else {
          // Unselect the button
          this.$emit('button-unselected');
          return;
        }
      }

      // Security for single selection buttons
      if (this.selectedConfigurationIndex == -1) {
        this.selectedConfigurationIndex = 0;
      }

      this.$emit('button-selected', this.$event, this.buttonId, this.currentlySelectedConfiguration.id);
    },
  },
  watch: {
    chosen(value) {
      if (!value) {
        this.selectedConfigurationIndex = -1;
      }
    },
  },
};
</script>

<style scoped>
/* Button */
#preset-button {
  height: 100%;
  border-radius: 1rem;
  font-size: 1rem;
  background-color: #99397322;
  transition: background-color 250ms;
  color: #993973;
}

@media screen and (max-width: 768px) {
  #preset-button {
    font-size: 0.75rem;
  }
}

#preset-button.filled {
  background-color: #993973;
  color: white;
}

#preset-button:hover {
  background-color: #99397355;
  color: #1f1f1f;
}

#preset-button.filled:hover {
  background-color: #993973dd;
  color: white;
}

/* Configuration */
.filled #configuration.not-selected {
  color: #1f1f1f;
}
</style>
